/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type CountryCode = typeof CountryCode[keyof typeof CountryCode];


export const CountryCode = {
  AD: 'AD',
  AE: 'AE',
  AT: 'AT',
  AW: 'AW',
  BE: 'BE',
  BS: 'BS',
  BZ: 'BZ',
  CA: 'CA',
  CH: 'CH',
  CL: 'CL',
  CO: 'CO',
  CR: 'CR',
  CZ: 'CZ',
  DE: 'DE',
  DK: 'DK',
  ES: 'ES',
  FR: 'FR',
  GR: 'GR',
  HR: 'HR',
  HU: 'HU',
  IE: 'IE',
  IT: 'IT',
  KY: 'KY',
  LI: 'LI',
  LU: 'LU',
  MF: 'MF',
  MG: 'MG',
  MU: 'MU',
  MX: 'MX',
  NL: 'NL',
  PA: 'PA',
  PL: 'PL',
  PT: 'PT',
  SM: 'SM',
  TC: 'TC',
  US: 'US',
  UY: 'UY',
  VG: 'VG',
  ZA: 'ZA',
} as const;
